
import {createModel} from "./model.js";

const schema = {
    show_settings:     ["boolean", false],
    show_date_chooser: ["boolean", false],
};

export const modalStore = createModel(schema);
